/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTournamentCapabilitiesDtoSchema = z.object({
  canRegister: z.optional(z.boolean()),
  canCancelRegistration: z.optional(z.boolean()),
  canApproveRegistrations: z.optional(z.boolean()),
  canAdjustPoints: z.optional(z.boolean()),
  canBlacklist: z.optional(z.boolean()),
  canUnblacklist: z.optional(z.boolean()),
  canGenerateBracket: z.optional(z.boolean()),
  canFreezeBracket: z.optional(z.boolean()),
  canUnfreezeBracket: z.optional(z.boolean()),
  canPublishBracket: z.optional(z.boolean()),
  canReshuffleBracket: z.optional(z.boolean()),
  canStartDraft: z.optional(z.boolean()),
  canEditTournament: z.optional(z.boolean()),
  canDeleteTournament: z.optional(z.boolean()),
  canManageSettings: z.optional(z.boolean()),
  canManageRegistrations: z.optional(z.boolean()),
  canManageBracket: z.optional(z.boolean()),
  canAddModerators: z.optional(z.boolean()),
  canManageTournament: z.optional(z.boolean()),
  disabledReasons: z.object({}).catchall(z.string()).nullish(),
});
